import { Type } from 'class-transformer'
import { Route } from './Router/Route'

export class Router {

  public readonly id: string

  @Type(() => Route)
  public readonly routes: Route[]

  constructor(id: string, routes: Route[]) {
    this.id = id
    this.routes = routes
  }
}
